import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux'

import { Button, PopOut, Spinner, Tooltip } from 'components';
import { FaAngleDown, FaRegQuestionCircle } from 'react-icons/fa';

import OptionBlock from './OptionBlock';
import Options from './Options';
import { Emoji } from 'emoji-mart'

const Container = styled.div`
    background-color: var(--primary-color);
    border-radius: 5px;
    box-shadow: var(--box-shadow);
    /* border: 1px solid var(--primary-accent-color); */
    cursor: pointer;
    margin: 0.5rem 0 0 0;
    border-style: solid;
    border-width: 2px;
    border-color: ${props => props.error ? 'var(--error-color)' : 'transparent'};
    :hover {
        filter: brightness(var(--brightness));
    }
`

const Wrapper = styled.div`
    width: 100%;
    padding: 0.25rem 0.5rem;
    display: grid;
    grid-template-columns: 1fr auto;
    grid-column-gap: 0.5rem;
    align-items: center;
`

const Label = styled.div`
    font-size: 0.8rem;
    font-weight: bold;
`

const Column = styled.div`
    width: 100%;
    overflow: hidden;
    display: flex;
    flex-direction: column;
`

const Row = styled.div`
    display: flex;
    align-items: center;
    margin: ${props => props.styles && props.styles.margin};
    justify-content: ${props => props.styles && props.styles.justifyContent};
`

const Icon = styled.img`
    height: 1rem;
    width: 1rem;
    object-fit: contain;
    src: ${props => props.icon};
    margin: 0 0.5rem 0 0;
`

const Error = styled.div`
    font-size: 0.8rem;
    color: var(--error-color);
    margin-left: 0.2rem;
    :before {
        content: '*'
    }
`

const Title = styled.div`
    line-height: 1.5rem;
    min-height: 1.5rem;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1; /* number of lines to show */
    -webkit-box-orient: vertical;
`

const Placeholder = styled.div`
    font-size: 0.8rem;
    padding: 0 0.25rem;
`

const Selector = props => {
    const {
        label,
        value,
        onSelect,
        styles,
        error,
        options, // [{title: xx, subtitle: xx, value: xx}, ...]
        optionPlaceholder,
        refreshOptions,
        helper
    } = props;
    const dispatch = useDispatch()
    const user = useSelector((state) => state.auth.user)

    const [open, setOpen] = useState(false)
    const [width, setWidth] = useState(styles && styles['width'])
    const [showSpinner, setSpinner] = useState(false)
    const ref = React.createRef()
    useEffect(() => {
        setWidth(ref.current.getBoundingClientRect()['width']+5)
    }, [])

    const getOptions = () => {
        let blocks;
        if(options && Object.values(options).length === 0){
            const styles = {
                margin: '0.5rem',
                justifyContent: 'center'
            }
            blocks = [
                <Row styles={styles}>{showSpinner ? 'Retrieving options' : "Couldn't retrieve options"}</Row>,
                <Row styles={styles}>
                    <Button text={showSpinner ? <Spinner styles={{color: 'var(--text-color)'}}/> : 'Refresh'} 
                        styles={{backgroundColor: 'var(--focus-color)', margin: 0, width: '5rem'}} 
                        onSelect={() => {
                            refreshOptions()
                            setSpinner(true)
                            setTimeout(() => {
                                setSpinner(false)
                            }, 5000)
                        }}/>
                </Row>
            ]
        } else {
            blocks = Object.values(options).map(option => (<OptionBlock title={option['title']} subtitle={option['subtitle']} icon={option['icon']} onSelect={() => onSelect(option['value'])}/>))
            if(blocks.length === 0){
                blocks = [<Placeholder>{optionPlaceholder}</Placeholder>]
            }
        }
        
        return <Options width={width} blocks={blocks}/>
    }

    const optionBlock = options && getOptions()
    const icon = options[value] && options[value]['icon']
    return (
        <Container error={error}>
            <PopOut trigger='leftClick' placement='bottom' element={optionBlock} onOpen={() => setOpen(true)} onClose={() => setOpen(false)}>
                <Wrapper ref={ref}>
                    <Column>
                        <Row styles={{margin: '0 0 0.2rem 0'}}>
                            <Label>{label}</Label>
                            {helper && 
                            <Tooltip title={helper}>
                                <div style={{display: 'flex', color: 'var(--secondary-accent-color)', fontSize: '0.8rem', margin: '0 0.3rem', cursor: 'pointer'}}><FaRegQuestionCircle/></div>
                            </Tooltip>}
                            {error && <Error>{error}</Error>}
                        </Row>
                        <Row>
                            {!icon ? null
                            : icon['type'] === 'link' ? <Icon src={icon['value']}/>
                            : icon['type'] === 'emoji' ? <div style={{margin: '0 0.5rem 0 0'}}><Emoji emoji={icon['value']} size={'1rem'} /></div>
                            : icon['type'] === 'element' ? <div style={{margin: '0 0.5rem 0 0', height: '1rem', width: '1rem'}}>{icon['value']}</div>
                            : null}
                            <Title>{options[value] && options[value]['title']}</Title>
                        </Row>
                    </Column>
                    <FaAngleDown style={{color: 'var(--secondary-color)', fontSize: '1.2rem', fontWeight: 'bold', transform: open && 'scaleY(-1)'}}/>
                </Wrapper>
            </PopOut>
        </Container>
    )
}

export default Selector